import React, { useContext, useState } from 'react';
import { Slider, Typography } from 'antd';
import { IoSpeedometerOutline } from 'react-icons/io5';
import AlertCard from './AlertCard';
import { ALERT_CATEGORY, triggerAlert } from '../../mqtt/aws';
import { SimulatorContext } from 'store/context';

const { Text } = Typography;

const SpeedAlert = ({ messageApi, onTriggered }) => {
  const { stsToken: credentials, vehicleSimulatorSettings: { serialNo, vehicleKey } } = useContext(SimulatorContext);
  const [speed, setSpeed] = useState(0);
  const [loading, setLoading] = useState(false);

  const triggerSpeedAlert = async () => {
    setLoading(true);
    await triggerAlert({ serialNo, vehicleKey, actual: speed, category: ALERT_CATEGORY.SPEED_ALERT, threshold: 80 }, credentials)
      .then(() => { messageApi.success('Speed alert triggered successfully'); onTriggered?.({ success: true, value: `${speed} km/h` }); })
      .catch(() => { messageApi.error('Failed to trigger speed alert'); onTriggered?.({ success: false, value: `${speed} km/h` }); })
      .finally(() => setLoading(false));
  };

  return (
    <AlertCard
      index={3}
      title="Over Speed"
      icon={<IoSpeedometerOutline />}
      iconBg="#fff7ed"
      iconColor="#f97316"
      threshold="80 km/h"
      onTrigger={triggerSpeedAlert}
      triggerLabel="Trigger Speed Alert"
      loading={loading}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Text style={{ fontSize: 11, color: '#64748b' }}>Current speed</Text>
        <Text style={{ fontSize: 20, fontWeight: 700, color: speed > 80 ? '#ef4444' : '#0f172a', lineHeight: 1 }}>
          {speed} <span style={{ fontSize: 12, fontWeight: 500, color: '#94a3b8' }}>km/h</span>
        </Text>
      </div>
      <Slider min={0} max={300} value={speed} onChange={setSpeed} />
    </AlertCard>
  );
};

export default SpeedAlert;
